<template>
  <FormModal title="Wanneer wil je de dakkapel plaatsen?" show-back-btn>
    <template #body>
      <ExecutionPeriodFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { PD_10103_REMOVE_DORMER_QUESTIONS } from 'chimera/all/constants/experiments'
import ExecutionPeriodFormStep from '~/components/form/steps/executionPeriod/ExecutionPeriodFormStep'

export default {
  components: {
    ExecutionPeriodFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Wanneer wil je de dakkapel plaatsen?',
      headDescription: 'Geef aan wanneer je de dakkapel wilt plaatsen.',
      path: '/offertes-aanvragen/wanneer-dakkapel-plaatsen',
    }
  },

  computed: {
    /**
     * @returns {boolean}
     */
    isVariantFlow() {
      const { getFromStore, isVariant } = useExperiments(this.$store)
      return isVariant(getFromStore(PD_10103_REMOVE_DORMER_QUESTIONS), 1)
    },

    /**
     * @returns {number}
     */
    progressValue() {
      return this.isVariantFlow ? 50 : 75
    },
  },

  /**
   * Set checkoutStep based on experiment variant.
   */
  mounted() {
    this.setCheckoutStep(this.isVariantFlow ? 1 : 5)
  },
}
</script>
